if (window.self !== window.top) {
  const sendHeight = () => {
    window.parent.postMessage(
      {
        type: "energy-tech-startups-resize-embed",
        height: document.body.scrollHeight,
      },
      "*",
    );
  };

  window.addEventListener("load", sendHeight);
  window.addEventListener("resize", sendHeight);

  const observer = new MutationObserver(sendHeight);
  observer.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    characterData: true,
  });

  sendHeight();
}
